module.exports = __webpack_public_path__ + "static/media/9DESA31.6f864301.jpg";